// extracted by mini-css-extract-plugin
export default {"typingIndicator":"AgentMessage_typingIndicator__BSc2H","dot":"AgentMessage_dot__47KKH","typingBounce":"AgentMessage_typingBounce__wwEka"};